import { render } from "./RegistrationPanel.vue?vue&type=template&id=c60aca1e&scoped=true"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"

import "./RegistrationPanel.vue?vue&type=style&index=0&id=c60aca1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c60aca1e"

export default script